'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import PrivacyAtGlanceCard from './PrivacyAtGlanceCard'
import usePrivacyAtGlanceCardContent from './usePrivacyAtGlanceCardContent'

const PrivacyAtGlanceSection = () => {
  const translate = useTranslate('privacy_center')
  const atGlanceSectionCards = usePrivacyAtGlanceCardContent()

  return (
    <section className="privacy-center__glance-section">
      <div>
        <h1 className="privacy-center__glance-title">{translate('title')}</h1>
        <h2 className="privacy-center__glance-subtitle">{translate('subtitle')}</h2>
      </div>
      <div className="privacy-center__glance-cards-container">
        {atGlanceSectionCards.map((card, index) => (
          <PrivacyAtGlanceCard {...card} key={index} />
        ))}
      </div>
    </section>
  )
}

export default PrivacyAtGlanceSection
